import {
  language_item,
  logout_item,
  profile_item,
  support_item,
} from '../../../../../components/layout/ProfileDropdown';

export default {
  items: {
    [profile_item]: 'Profiili',
    [language_item]: 'Vaihda kieli',
    [support_item]: 'Tuki',
    [logout_item]: 'Kirjaudu ulos',
  },
};
